import React from 'react';

const StepIndicator = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="twitter-bs-wizard mb-4">
      <div className="twitter-bs-wizard-nav">
        <div className="row text-center">
          {steps.map((step, index) => {
            const isActive = step.id === currentStep;
            const isCompleted = step.id < currentStep;
            const isClickable = step.id <= currentStep;

            return (
              <div key={step.id} className="col-4">
                <div
                  className={`nav-link ${isActive ? 'active' : ''}`}
                  onClick={() => isClickable && onStepClick(step.id)}
                  style={{ cursor: isClickable ? 'pointer' : 'default' }}
                >
                  <div className="d-flex align-items-center justify-content-center flex-column flex-md-row">
                    <span className={`step-number mr-md-2 mb-2 mb-md-0 ${isCompleted ? 'bg-success border-success text-white' : ''}`}>
                      {isCompleted ? (
                        <i className="bx bx-check"></i>
                      ) : (
                        step.id
                      )}
                    </span>
                    <div className="text-center text-md-left">
                      <h6 className="mb-0 font-weight-bold d-none d-md-block">
                        {step.title}
                      </h6>
                      <small className="text-muted d-none d-md-block">
                        {step.description}
                      </small>
                      <small className="d-block d-md-none font-weight-bold">
                        {step.title}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StepIndicator;